export const setHeader = (values) => ({
  type: 'SET_HEADER',
  payload: values
})



// WEBPACK FOOTER //
// ./src/actions/header.js